module.exports = __webpack_public_path__ + "media/sunset.c382f731.mp3";